// import Animation from "../../Animations";
import { useRouter } from "next/router";
import useCreditNudgeStore from "../../zustandStores/useCreditNudgeStore";
import useCreditProfileStore from "../../zustandStores/userCreditProfileStore";
import styles from "./credit.module.css";
// import buttonAnimation from "../../Animations/lottie-files/buttonAnimation.json";
import cns from "classnames";
import { Routes } from "../../routes/RouteConstants";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import { isMobileDevice } from "../../services/utils";
function CreditBar({
  view,
  onBtnClickView1,
  btnTextView1 = "Buy credits",
  onBtnClickView2,
  view1DesktopMessage1 = "",
  view1DesktopMessage2 = "",
  view1MobileMessage1 = "",
  info
}) {
  const router = useRouter();
  const { creditData = {}, isCreditBetaUser } = useCreditProfileStore(
    state => ({
      creditData: state.data,
      isCreditBetaUser: state.isCreditBetaUser
    })
  );
  const { creditNudge = {}, setCreditNudgeData } = useCreditNudgeStore(
    state => ({
      creditNudge: state.data,
      setCreditNudgeData: state.setCreditNudgeData
    })
  );
  const hasPurchasedCredits = creditData.hasPurchasedCredits;
  const totalCredit = creditData.totalAvailableCredits;
  const hideTopBar = creditNudge.hideTopBar;
  let btnTextInternal = btnTextView1;
  if (info === "DASHBOARD") {
    btnTextInternal = hasPurchasedCredits ? "Buy more" : "Buy credits";
  }
  if (info === "CMP") {
    btnTextInternal = isMobileDevice() ? "Upgrade Now" : "Upgrade to Premium";
  }
  if (hasPurchasedCredits === false) {
    view1DesktopMessage1 = view1DesktopMessage1 || "Want to hire faster?";
    view1DesktopMessage2 =
      view1DesktopMessage2 || "Buy credits to post Premium jobs";
    view1MobileMessage1 =
      view1MobileMessage1 || "Hire faster with Premium jobs";
  }
  if (hasPurchasedCredits === true && totalCredit == 0) {
    view1DesktopMessage1 =
      view1DesktopMessage1 || "Your credit balance is running low!";
    view1DesktopMessage2 =
      view1DesktopMessage2 || "Buy credits to keep posting Premium jobs";
    view1MobileMessage1 =
      view1MobileMessage1 || "Your credit balance is running low!";
  }
  if (!isCreditBetaUser) {
    return null;
  }
  if (view === "view2") {
    return (
      <div id="credit_bar_2" className={styles.view2Container}>
        <img src="/hire/userprem.svg" alt="premium" />
        <div className={styles.infoDesktop}>
          Need more applies? Upgrade to Premium to get boosted job visibility
        </div>
        <div className={styles.infoMobile}>Need to hire faster?</div>

        <button
          onClick={() => {
            onBtnClickView2();
          }}
          className={cns(styles.buyButton, "hidden md:flex")}
        >
          Upgrade To Premium
        </button>
        <button
          onClick={() => {
            onBtnClickView2();
          }}
          className={cns(styles.buyButton, "flex md:hidden")}
        >
          Upgrade Now
        </button>
      </div>
    );
  }
  if (
    !hideTopBar &&
    view === "view1" &&
    view1DesktopMessage1 &&
    view1MobileMessage1
  ) {
    return (
      <div id="credit_bar_1" className={styles.container}>
        <img className={styles.info} src="/hire/info-circle.svg" />
        <div className={styles.balanceInfoDesktop}>
          <b>{view1DesktopMessage1}</b>
          <span className={styles.msg2}> &nbsp; {view1DesktopMessage2} </span>
        </div>
        <div className={styles.balanceInfoMobile}>
          <span>{view1MobileMessage1}</span>
        </div>
        <div className={styles.buttonContainer}>
          <button
            onClick={() => {
              if (onBtnClickView1) {
                onBtnClickView1();
                return;
              }
              router.push(`${Routes.PLAN_SELECTION}?eventSource=creditBar`);
            }}
            className={cns(styles.buyButton, "d-flex")}
          >
            {btnTextInternal}
          </button>
        </div>
        <img
          onClick={() => {
            LogService.log(CREDIT_EVENTS.TRIAL_BAR_CROSS, {
              source: info || ""
            });
            setCreditNudgeData({ hideTopBar: true });
          }}
          className={styles.cross}
          src="/hire/cross.svg"
        />
      </div>
    );
  }

  return null;
}

export default CreditBar;
